<template>
  <div class="qam-calc-box" id="pass32" v-if="selectedDiv == '32'">
    <v-row>
      <v-col cols="12">
        <h3>
          Es tut uns leid. Zu dem angegebenen Flug konnten wir keine Angebote
          von Fluggastportalen finden. Aufschluss über mögliche Gründe gibt
          folgende Komplettübersicht zu den
          <a
            href="https://www.qam-qam.com/flugentschaedigung-gesamtueberblick/"
            target="_blank"
            >Voraussetzungen einer Flugentschädigung</a
          >. Sollten Sie diese allesamt erfüllen, überprüfen Sie gegebenenfalls
          noch einmal Ihre Eingaben oder wenden Sie sich direkt an die Anbieter
          aus unserem
          <a
            href="https://www.qam-qam.com/fluggastportale/#overview"
            target="_blank"
            >Gesamtvergleich</a
          >.
        </h3>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "RejectionTile",
  computed: mapState(["selectedDiv"]),
};
</script>
